module.exports = __webpack_public_path__ + "static/media/chromeAddToHomeScreen.bff76845.svg";